import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["checkedOptions", "children", "className", "cols", "direction", "disabledOptions", "id", "invalidOptions", "mode", "onChange", "options", "size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, Children, useCallback, useEffect, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import Checkbox from '../Checkbox';
import { Styled } from './CheckboxGroup.styles';
import { jsx as _jsx } from "react/jsx-runtime";
var CheckboxGroup = forwardRef(function (_ref, ref) {
  var _cx;

  var initialCheckedOptions = _ref.checkedOptions,
      children = _ref.children,
      customClassName = _ref.className,
      _ref$cols = _ref.cols,
      cols = _ref$cols === void 0 ? 2 : _ref$cols,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'ltr' : _ref$direction,
      initialDisabledOptions = _ref.disabledOptions,
      id = _ref.id,
      initialInvalidOptions = _ref.invalidOptions,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'light' : _ref$mode,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {
    return null;
  } : _ref$onChange,
      optionsFromProp = _ref.options,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-checkboxgroup"), true), _defineProperty(_cx, customClassName, !!customClassName), _cx));

  var _useState = useState(initialCheckedOptions),
      _useState2 = _slicedToArray(_useState, 2),
      checkedOptions = _useState2[0],
      setCheckedOptions = _useState2[1];

  var _useState3 = useState(initialDisabledOptions),
      _useState4 = _slicedToArray(_useState3, 2),
      disabledOptions = _useState4[0],
      setDisabledOptions = _useState4[1];

  var _useState5 = useState(initialInvalidOptions),
      _useState6 = _slicedToArray(_useState5, 2),
      invalidOptions = _useState6[0],
      setInvalidOptions = _useState6[1];

  var groupOptions = useCallback(function (options) {
    if (direction === 'ltr') {
      return Array.from({
        length: cols
      }, function (v, index) {
        return options.filter(function (o, i) {
          return i % cols === index;
        });
      });
    } else if (direction === 'ttb') {
      return Array.from({
        length: cols
      }, function (v, index) {
        var size = Math.ceil(options.length / cols);
        return options.slice(index * size, index * size + size);
      });
    }
  }, [cols, direction]);

  var _useState7 = useState(function () {
    if (optionsFromProp) {
      return groupOptions(optionsFromProp);
    } else if (children) {
      return groupOptions(Children.toArray(children));
    }
  }),
      _useState8 = _slicedToArray(_useState7, 2),
      options = _useState8[0],
      setOptions = _useState8[1];

  var handleChange = function handleChange(option) {
    var updatedCheckedOptions;

    if (checkedOptions) {
      updatedCheckedOptions = checkedOptions.includes(option.value) ? checkedOptions.filter(function (value) {
        return value !== option.value;
      }) : [].concat(_toConsumableArray(checkedOptions), [option.value]);
    } else {
      updatedCheckedOptions = [option.value];
    }

    setCheckedOptions(updatedCheckedOptions);
    onChange(updatedCheckedOptions);
  };

  var renderColumns = function renderColumns() {
    var columns = options.map(function (column, index) {
      return _jsx("div", {
        className: "".concat(prefix, "-checkboxgroup__column"),
        children: column.map(function (option, index) {
          var checkbox = optionsFromProp ? option : children ? option.props : null;
          return _jsx(Checkbox, {
            id: checkbox.id,
            className: "".concat(prefix, "-checkboxgroup__checkbox"),
            isChecked: checkedOptions && checkedOptions.includes(checkbox.value),
            isDisabled: disabledOptions && disabledOptions.includes(checkbox.value),
            isInvalid: invalidOptions && invalidOptions.includes(checkbox.value),
            onChange: function onChange() {
              return handleChange(checkbox);
            },
            children: optionsFromProp ? option.label : children ? option.props.children : null
          }, checkbox.value);
        })
      }, index);
    });
    return columns;
  };

  useEffect(function () {
    if (optionsFromProp) {
      setOptions(function () {
        return groupOptions(optionsFromProp);
      });
    }
  }, [optionsFromProp, groupOptions]);
  useEffect(function () {
    setCheckedOptions(initialCheckedOptions);
  }, [initialCheckedOptions]);
  useEffect(function () {
    setDisabledOptions(initialDisabledOptions);
  }, [initialDisabledOptions]);
  useEffect(function () {
    setInvalidOptions(initialInvalidOptions);
  }, [initialInvalidOptions]);
  return _jsx(ThemeProvider, {
    theme: {
      mode: mode,
      size: size
    },
    children: _jsx(Styled.CheckboxGroup, _objectSpread(_objectSpread({
      ref: ref,
      id: id,
      className: className,
      cols: cols
    }, rest), {}, {
      children: renderColumns()
    }))
  });
});
export default CheckboxGroup;